import { dataGridFilterBuilder } from '../store/api/query-builders/data-grid/filter/data-grid-filter.builder';
import { GridLinkOperator } from '@mui/x-data-grid-pro';

export const filterByName = (v: string) => {
  if (!v) {
    return '';
  }

  return dataGridFilterBuilder({
    items: [
      {
        columnField: 'userInfo.fullName',
        id: 0,
        operatorValue: 'contains',
        value: v,
      },
      {
        columnField: 'candidateFullName',
        id: 0,
        operatorValue: 'contains',
        value: v,
      },
      {
        columnField: 'employeeId',
        id: 1,
        operatorValue: 'contains',
        value: v,
      },
    ],
    linkOperator: GridLinkOperator.Or,
    quickFilterValues: [],
    quickFilterLogicOperator: GridLinkOperator.Or,
  });
};
